__turbopack_context__.v({
  "thumb": "Switch-module__AO5sqG__thumb",
  "track": "Switch-module__AO5sqG__track",
});
